import { signal } from '@preact/signals-react';
import { range } from 'underscore';

const jsonData = signal({
	languages: [], // common
	currentLanguage: {
		code: '',
		nameChinese: '',
		nameNative: '',
	},
	basicInfo: {
		name: '',
		intro: '',
		link: '',
		floorCount: 1, // common
		boothColor: {
			// common
			fill: '',
			fillOpacity: 0,
			border: '',
			borderOpacity: 0,
			text: '',
			textOpacity: 0,
		},
	},
	floorInfo: range(20).map(() => {
		return {
			name: '',
			map: {
				url: '',
				width: '',
				height: '',
			},
			floor: '', // common
			booths: [], // common
			sections: [], // common except for name
			paths: [], // common
			floorLinks: [], // common
		};
	}),
	exhibitorInfo: [],
	productInfo: [],
	navigationInfo: [],
});

export default jsonData;
